import { render, staticRenderFns } from "./TopTabbar.vue?vue&type=template&id=6eb2e0d6&scoped=true&"
import script from "./TopTabbar.vue?vue&type=script&lang=js&"
export * from "./TopTabbar.vue?vue&type=script&lang=js&"
import style0 from "./TopTabbar.vue?vue&type=style&index=0&id=6eb2e0d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eb2e0d6",
  null
  
)

export default component.exports